import { create } from 'zustand';

interface CustomerUiState {
  isMobileSidebarOpen: boolean;
  setMobileSidebarOpen: (open: boolean) => void;
}

/**
 * Customer Portal UI refinement — isolated from the shared `useUiStore`
 * (frontend/src/stores/ui.store.ts), which is a single persisted instance
 * shared by identity across the staff, Platform, and Customer Portal app
 * branches. The Customer Portal sidebar has no collapse toggle control (only
 * 3 nav items) and was previously reading `sidebarCollapsed` from that shared
 * store, meaning its desktop width was silently dictated by whatever the
 * staff/platform app last set in the same browser profile. This store has no
 * `sidebarCollapsed` at all (the Customer Portal sidebar is always expanded
 * on desktop) and is not `persist`-backed, mirroring how `customer-auth.store.ts`
 * is already correctly isolated from `useAuthStore`/`usePlatformAuthStore`.
 */
export const useCustomerUiStore = create<CustomerUiState>()((set) => ({
  isMobileSidebarOpen: false,
  setMobileSidebarOpen: (open) => set({ isMobileSidebarOpen: open }),
}));
